import { z, uuidSchema } from '@kc3/validation';
import { baseEventFields } from './_base.js';
export const NotificationCreatedEventSchema = z.object({
    type: z.literal('notification.created'),
    ...baseEventFields,
    notificationId: uuidSchema,
    recipientId: uuidSchema,
    eventKey: z.string().min(1),
    title: z.string(),
    description: z.string(),
    conversationId: uuidSchema.nullable(),
    campaignId: uuidSchema.nullable(),
    campaignName: z.string().nullable(),
    actorName: z.string().nullable(),
    assigneeName: z.string().nullable(),
    entityType: z.string().nullable().optional(),
});
/**
 * client.notification.created — a portal customer got a new in-app notification
 * (a row in in_app_notifications with recipient_client_id). The ws-gateway
 * relays it to that client's room so the portal bell refreshes at once instead
 * of polling the API. Carries ids only; the bell fetches the content itself.
 */
export const ClientNotificationCreatedEventSchema = z.object({
    type: z.literal('client.notification.created'),
    ...baseEventFields,
    clientId: uuidSchema,
    notificationId: uuidSchema,
});
//# sourceMappingURL=notification.js.map